// TODO: Uncomment code once API calls are available
export enum ComplianceReportPath {
  paystub = "paystub",
  cashBalance = "cash-balance",
  dduConsent = "ddu-consent",
  // canceledUsers = "canceled-users",
}

export interface ComplianceReportTab {
  path: ComplianceReportPath;
  label: string;
}

export const ComplianceReportLabel: Record<ComplianceReportPath, string> = {
  [ComplianceReportPath.paystub]: "Paystub Report",
  [ComplianceReportPath.cashBalance]: "Cash Balance Report",
  [ComplianceReportPath.dduConsent]: "DDU Consent Report",
};

// Hide reports that still use mock data
// TODO: Uncomment code once API calls are available
export const complianceReportTabs: ComplianceReportTab[] = [
  {
    path: ComplianceReportPath.paystub,
    label: ComplianceReportLabel[ComplianceReportPath.paystub],
  },
  {
    path: ComplianceReportPath.cashBalance,
    label: ComplianceReportLabel[ComplianceReportPath.cashBalance],
  },
  {
    path: ComplianceReportPath.dduConsent,
    label: ComplianceReportLabel[ComplianceReportPath.dduConsent],
  },
  // {
  //   path: ComplianceReportPath.canceledUsers,
  //   label: "Canceled Users Report"
  // },
];

export const tabPaths = complianceReportTabs.map(tab => tab.path);
export const tabLabels = complianceReportTabs.map(tab => tab.label);

export const ROWS_PER_COMPLIANCE_REPORT_PAGE = 10;
